module.exports = __webpack_public_path__ + "img/mgh-nagoya.5d75dccf.jpg";